import { render, staticRenderFns } from "./normal-radio.vue?vue&type=template&id=0c8f55f9&scoped=true&"
import script from "./normal-radio.vue?vue&type=script&lang=js&"
export * from "./normal-radio.vue?vue&type=script&lang=js&"
import style0 from "./normal-radio.vue?vue&type=style&index=0&id=0c8f55f9&prod&scoped=true&lang=less&"
import style1 from "./normal-radio.vue?vue&type=style&index=1&id=0c8f55f9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8f55f9",
  null
  
)

export default component.exports